'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Caption1", {
    enumerable: true,
    get: function() {
        return Caption1;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _createPreset = require("../createPreset");
const _useCaption1Stylesstyles = require("./useCaption1Styles.styles");
const Caption1 = (0, _createPreset.createPreset)({
    useStyles: _useCaption1Stylesstyles.useCaption1Styles,
    className: _useCaption1Stylesstyles.caption1ClassNames.root,
    displayName: 'Caption1'
});
